import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const TableStove = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5 3.875C4.37868 3.875 3.875 4.37868 3.875 5C3.875 5.62132 4.37868 6.125 5 6.125C5.62132 6.125 6.125 5.62132 6.125 5C6.125 4.37868 5.62132 3.875 5 3.875ZM3.125 5C3.125 3.96447 3.96447 3.125 5 3.125C6.03553 3.125 6.875 3.96447 6.875 5C6.875 6.03553 6.03553 6.875 5 6.875C3.96447 6.875 3.125 6.03553 3.125 5Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M5 9.875C4.37868 9.875 3.875 10.3787 3.875 11C3.875 11.6213 4.37868 12.125 5 12.125C5.62132 12.125 6.125 11.6213 6.125 11C6.125 10.3787 5.62132 9.875 5 9.875ZM3.125 11C3.125 9.96447 3.96447 9.125 5 9.125C6.03553 9.125 6.875 9.96447 6.875 11C6.875 12.0355 6.03553 12.875 5 12.875C3.96447 12.875 3.125 12.0355 3.125 11Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M9.125 3.5C9.125 3.29289 9.29289 3.125 9.5 3.125H12.5C12.7071 3.125 12.875 3.29289 12.875 3.5C12.875 3.70711 12.7071 3.875 12.5 3.875H9.5C9.29289 3.875 9.125 3.70711 9.125 3.5Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M9.125 5.5C9.125 5.29289 9.29289 5.125 9.5 5.125H12.5C12.7071 5.125 12.875 5.29289 12.875 5.5C12.875 5.70711 12.7071 5.875 12.5 5.875H9.5C9.29289 5.875 9.125 5.70711 9.125 5.5Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M9.125 9.5C9.125 9.29289 9.29289 9.125 9.5 9.125H12.5C12.7071 9.125 12.875 9.29289 12.875 9.5C12.875 9.70711 12.7071 9.875 12.5 9.875H9.5C9.29289 9.875 9.125 9.70711 9.125 9.5Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M9.125 11.5C9.125 11.2929 9.29289 11.125 9.5 11.125H12.5C12.7071 11.125 12.875 11.2929 12.875 11.5C12.875 11.7071 12.7071 11.875 12.5 11.875H9.5C9.29289 11.875 9.125 11.7071 9.125 11.5Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M1.5 1.875C1.15482 1.875 0.875 2.15482 0.875 2.5V13.5C0.875 13.8452 1.15482 14.125 1.5 14.125H14.5C14.8452 14.125 15.125 13.8452 15.125 13.5V2.5C15.125 2.15482 14.8452 1.875 14.5 1.875H1.5ZM0.125 2.5C0.125 1.74061 0.740608 1.125 1.5 1.125H14.5C15.2594 1.125 15.875 1.74061 15.875 2.5V13.5C15.875 14.2594 15.2594 14.875 14.5 14.875H1.5C0.740608 14.875 0.125 14.2594 0.125 13.5V2.5Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

TableStove.category = 'product-category';

TableStove.displayName = 'TableStove';
